import React, { useCallback } from 'react'
import { graphql } from 'gatsby'

import PasswordGenerator from '@/components/section-password-generator'
import PasswordStrengthTester from '@/components/section-password-test'
import HostForm from '@/components/forms/host'
import JobsList from '@/components/ui/jobs-list'
import ComparisonGrid from '@/components/ui/comparison-grid'
import DownloadTabs from '@/components/ui/download-tabs'
import { ExperienceMapper } from '@ninetailed/experience.js-utils'
import { Experience } from '@ninetailed/experience.js-gatsby'

export const fragment = graphql`
  fragment SectionPrebuilt on ContentfulSectionPrebuilt {
    id
    contentful_id
    __typename
    name
    properties {
      internal {
        content
      }
    }
  }
`

export default function Prebuilt(props): JSX.Element {
  const mapExperiences = useCallback((experiences) => {
    if (!experiences || experiences.length === 0 || !experiences[0]?.variants) return []

    return experiences
      .map(({ variants, ...rest }) => ({
        ...rest,
        variants: variants.map((v) => ({ ...v, id: v.contentful_id })),
      }))
      .filter(ExperienceMapper.isExperienceEntry)
      .map(ExperienceMapper.mapExperience)
  }, [])

  return (
    <Experience
      {...props}
      id={props.contentful_id ?? props.id}
      key={props.contentful_id ?? props.id}
      experiences={mapExperiences(props.nt_experiences)}
      component={PrebuiltFunc}
      passthroughProps={{ ...props }}
    />
  )
}

export function PrebuiltFunc({ name, properties }: Queries.ContentfulSectionPrebuilt): JSX.Element {
  const props = JSON.parse(properties?.internal?.content || '{}')
  return (
    <>
      {name === 'Password Generator' && <PasswordGenerator {...props} />}
      {name === 'Password Strength Tester' && <PasswordStrengthTester {...props} />}
      {name === 'Host Form' && <HostForm {...props} />}
      {name === 'Jobs list' && <JobsList />}
      {(name === 'Business Comparison Table' ||
        name === 'Individual Comparison Table' ||
        name === 'Secrets Manager Plans' ||
        name === 'Business Comparison Table - Teams Variant' ||
        name === 'Business Comparison Table - Teams Baseline' ||
        name === 'Bitwarden Product Comparison') && <ComparisonGrid data={properties.internal} />}
      {name === 'Download Extension' && <DownloadTabs {...props} type="browsers" />}
      {name === 'Download Applications' && <DownloadTabs {...props} type="os" />}
    </>
  )
}
